module.exports = __webpack_public_path__ + "static/media/camera.8931be47.svg";